// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","703":"LazyIdentificationBusinessForm","886":"LazyInvitationStep","954":"LazyBusinessInfoFormComponent"}[chunkId] + "." + {"99":"e5ecabe5e4ab844f6ff1","703":"32862623e7a4d312c73a","886":"159dd33901420a98ee35","954":"c678ad1862acaa6e25f5"}[chunkId] + ".js";
};